import { req } from '../../@api/request';

export default class DeleteAccountService {
  static withdrawal = async (
    tel: string,
    reasonCode: string,
    reason?: string,
  ) => {
    const result = await req.post('/users/withdrawal', {
      tel,
      reasonCode,
      reason,
    });
    return result.data;
  };

  static sendCode = async (tel: string) => {
    const result = await req.post('/users/auth/otp/send/withdrawal', {
      tel,
    });
    return result.data;
  };

  static verifyCode = async (tel: string, authCode: string) => {
    const result = await req.post('/users/auth/otp/verify/withdrawal', {
      tel,
      authCode,
    });
    return result.data;
  };
}
